export const aiAgentPreferencesKeys = {
  MEMORY: 'generalsetting.orgpreferences.aiagent.memory',
};
